import { h, render, Component } from 'preact';
import { classNames } from '../utils/utils';

class TxrPagination extends Component {
    state = {
        page: 0,
        canNext: false,
        canPrev: false
    }
    pages(total, pageSize) {
        return Math.ceil(total / pageSize);
    }
    canNext(total, pageSize, page) {
        return (page + 1) * pageSize < total;
    }
    canPrev(page) {
        return page > 0;
    }
    selectPage = (value) => {
        if (value < 0 || value >= this.pages(this.props.total, this.props.pageSize)) {
            return;
        }
        this.props.selectPage(value);
        this.setState({ page: value });
        this.setState({ canNext: this.canNext(this.props.total, this.props.pageSize, value), canPrev: this.canPrev(value) });
        
    }
    componentDidMount() {
        this.props.refresh.refreshState = (total, pageSize, page) => {
            this.setState({ page: page });
            this.setState({ canNext: this.canNext(total, pageSize, page), canPrev: this.canPrev(page) });
        };
    }
    render() {
        return (
            <div class="txr-pagination">
                <span class={'pagination-button left' + (this.state.canPrev ? '' : ' disabled')} onClick={() => this.selectPage(this.state.page - 1)}><a><i class="far fa-angle-left"></i></a></span>
                <span class="pagination-edit">
                    <input type="number" min="1" value={this.state.page + 1} /> of <span class="pages-total">{this.pages(this.props.total, this.props.pageSize)}</span>
                </span>
                <span class={'pagination-button right' + (this.state.canNext ?'' : ' disabled')} onClick={() => this.selectPage(this.state.page + 1)}><a ><i class="far fa-angle-right"></i></a></span>
            </div>
        )
    }
}
export default TxrPagination;